import createSetItemField from 'owa-mail-store/lib/services/utils/createSetItemField';
import InferenceClassification from 'owa-service/lib/contract/InferenceClassification';
import ItemChange from 'owa-service/lib/contract/ItemChange';
import itemChange from 'owa-service/lib/factory/itemChange';
import itemId from 'owa-service/lib/factory/itemId';
import PropertyUpdate from 'owa-service/lib/contract/PropertyUpdate';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import UpdateItemResponseMessage from 'owa-service/lib/contract/UpdateItemResponseMessage';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

function createRequestBody(
    itemIdsToUpdate: string[],
    hashtagToWrite: string,
    hashtagBaseToWrite: string,
    inferenceClassificationToWrite?: InferenceClassification
) {
    const itemChanges: ItemChange[] = [];
    for (const messageItemId of itemIdsToUpdate) {
        const itemUpdates: PropertyUpdate[] = [];

        if (inferenceClassificationToWrite) {
            itemUpdates.push(
                createSetItemField('InferenceClassification', inferenceClassificationToWrite)
            );
        }

        itemUpdates.push(
            createSetItemField('Hashtags', hashtagToWrite === '' ? [] : [hashtagToWrite])
        );

        itemUpdates.push(<PropertyUpdate>{
            __type: 'SetItemField:#Exchange',
            Path: {
                __type: 'ExtendedPropertyUri:#Exchange',
                DistinguishedPropertySetId: 'PublicStrings',
                PropertyName: 'HashtagsBase',
                PropertyType: 'StringArray',
            },
            Item: {
                __type: 'Message:#Exchange',
                ExtendedProperty: [
                    {
                        __type: 'ExtendedPropertyType:#Exchange',
                        ExtendedFieldURI: {
                            __type: 'ExtendedPropertyUri:#Exchange',
                            DistinguishedPropertySetId: 'PublicStrings',
                            PropertyName: 'HashtagsBase',
                            PropertyType: 'StringArray',
                        },
                        Values: [hashtagBaseToWrite],
                    },
                ],
            },
        });

        const singleItemChange = itemChange({
            Updates: itemUpdates,
            ItemId: itemId({
                Id: messageItemId,
            }),
        });

        itemChanges.push(singleItemChange);
    }

    // MessageDisposition attribue is needed for UpdateItem call
    return updateItemRequest({
        ConflictResolution: 'AlwaysOverwrite',
        ItemChanges: itemChanges,
        OutboundCharset: 'AutoDetect',
        MessageDisposition: 'SaveOnly',
    });
}

export default function updateHashtagsService(
    itemIdsToUpdate: string[],
    hashtagToWrite: string,
    hashtagBaseToWrite: string,
    inferenceClassification?: InferenceClassification
): Promise<UpdateItemResponseMessage> {
    const requestBody = createRequestBody(
        itemIdsToUpdate,
        hashtagToWrite,
        hashtagBaseToWrite,
        inferenceClassification
    );

    const jsonRequestHeader = getJsonRequestHeader();
    jsonRequestHeader.TimeZoneContext.TimeZoneDefinition.Id = 'UTC';

    return updateItemOperation({
        Header: jsonRequestHeader,
        Body: requestBody,
    })
        .then(response => {
            return response.Body.ResponseMessages.Items[0] as UpdateItemResponseMessage;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
